import { DataBlock } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function HiddenDetails({ person, conclusion, showHiddenDetails }) {
  const { t } = useTranslation()
  const lastModifiedDate = conclusion?.attribution?.modifiedDateNormalized?.[0]?.value
  const lastModifiedContactName = person?.contactNames?.[conclusion?.attribution?.contributor?.id]
  const reasonInfoIsCorrect = conclusion?.attribution?.changeMessage

  return (
    <>
      {showHiddenDetails && (
        <>
          {reasonInfoIsCorrect && (
            <DataBlock
              heading={`${t('tools.adminMerge.labels.reasonInfoIsCorrect', 'Reason This Information Is Correct')}:`}
              data={reasonInfoIsCorrect}
            />
          )}
          <DataBlock
            heading={t('tools.adminMerge.labels.lastChanged', 'Last changed: {date}', {
              date: lastModifiedDate,
            })}
            data={lastModifiedContactName}
          />
        </>
      )}
    </>
  )
}
